module.exports = __webpack_public_path__ + "media/images/redesign-images/shared/default-social-image-8977b59c5ebe3e8149ffb3469ea36479.jpg";